// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../configs';
import getRoot from './root';

const useAMPStore = create((set) => ({
  loading: { getAmpData: false },
  ampData: {},

  reset: () => set({ loading: { getAmpData: false } }),

  getAmpData: async () => {
    set((s) => ({ loading: { ...s.loading, getAmpData: true } }));
    try {
      const { data } = await axios.get(`${API_URL}/api/amp/overview-stats`);
      if (data.success) set({ ampData: data.overviewStats });
    } catch (e) {
      getRoot().failure('Failed to get AMP overview data...');
    }
    set((s) => ({ loading: { ...s.loading, getAmpData: false } }));
    return undefined;
  },
}));

export default useAMPStore;
